<app-nav-menu></app-nav-menu>
<div class="container pt-5 height-100">
  <div class="">
    <h1 class="dashboard-head">Travel Insurance</h1>
    <p class="opt-text">Select any service to proceed.</p>
    <div class="section_our_solution">
      <div class="row justify-content-center">
        <div class="">
          <p-tabs value="0">
            <p-tabpanels>
              <p-tabpanel value="0">

              <div class="col-sm-12 table-responsive">
                <table class="table" style="width:100%">
                  <thead>
                    <tr>
                      <th>Menu</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (insuranceRights.issue) {
                      <tr>
                        <td>Issue Policy</td>
                        <td>
                          <div class="so_top_icon" (click)="routeToIssue()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16" fill="currentColor">
                              <path fill-rule="evenodd" d="M3,1 C3,0.44772 3.44772,0 4,0 L6,0 C6.55228,0 7,0.44772 7,1 L7,2 C7,2.55228 6.55228,3 6,3 L4,3 C3.44772,3 3,2.55228 3,2 L3,1 Z M2,1 L0,1 L0,14 L10,14 L10,1 L8,1 L8,2.4 L8.6,2.4 L8.6,12.6 L1.4,12.6 L1.4,2.4 L2,2.4 L2,1 Z M4.57808,10.0212 L7.9899,6.6094 L6.99996,5.61945 L4.57808,8.04132 L3.36715,6.83038 L2.3772,7.82033 L4.57808,10.0212 Z" transform="translate(3 1)" />
                            </svg>
                          </div>
                        </td>
                      </tr>
                    }
                    @if (insuranceRights.view) {
                      <tr>
                        <td>Search Booked Policy</td>
                        <td>
                          <div class="so_top_icon" (click)="routeToBooked('00')">
                            <svg fill="currentColor" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m11.5 21.75c-5.65 0-10.25-4.6-10.25-10.25s4.6-10.25 10.25-10.25 10.25 4.6 10.25 10.25-4.6 10.25-10.25 10.25zm0-19c-4.83 0-8.75 3.93-8.75 8.75s3.92 8.75 8.75 8.75 8.75-3.93 8.75-8.75-3.92-8.75-8.75-8.75z" /><path d="m22.0004 22.7499c-.19 0-.38-.07-.53-.22l-2-2c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z" /></g></svg>
                          </div>
                        </td>
                      </tr>
                    }
                    @if (insuranceRights.cancel) {
                      <tr>
                        <td>Cancel Booked Policy</td>
                        <td>
                          <div class="so_top_icon" (click)="routeToCancel()">
                            <svg viewBox="0 0 512 512" style="fill:#FFAA00" width="32" height="32" xmlns="http://www.w3.org/2000/svg"><path d="m400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248-136.5.3-248.3-111-248.5-247.6-.1-83.3 40.9-157.1 103.8-202.2 11.7-8.3 28-4.8 35 7.7l15.8 28.1c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zm-104 209.9v-240c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z" /></svg>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </p-tabpanel>
            <!--<p-tabpanel value="1">
            <div class="col-sm-12 table-responsive">
              <table class="table" style="width:100%">
                <thead>
                  <tr>
                    <th>Menu</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Issue Policy</td>
                    <td>
                      <div class="so_top_icon" (click)="routeToUnitedIssue()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16" fill="currentColor">
                          <path fill-rule="evenodd" d="M3,1 C3,0.44772 3.44772,0 4,0 L6,0 C6.55228,0 7,0.44772 7,1 L7,2 C7,2.55228 6.55228,3 6,3 L4,3 C3.44772,3 3,2.55228 3,2 L3,1 Z M2,1 L0,1 L0,14 L10,14 L10,1 L8,1 L8,2.4 L8.6,2.4 L8.6,12.6 L1.4,12.6 L1.4,2.4 L2,2.4 L2,1 Z M4.57808,10.0212 L7.9899,6.6094 L6.99996,5.61945 L4.57808,8.04132 L3.36715,6.83038 L2.3772,7.82033 L4.57808,10.0212 Z" transform="translate(3 1)" />
                        </svg>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Search Booked Policy</td>
                    <td>
                      <div class="so_top_icon" (click)="routeToBooked()">
                        <svg fill="currentColor" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m11.5 21.75c-5.65 0-10.25-4.6-10.25-10.25s4.6-10.25 10.25-10.25 10.25 4.6 10.25 10.25-4.6 10.25-10.25 10.25zm0-19c-4.83 0-8.75 3.93-8.75 8.75s3.92 8.75 8.75 8.75 8.75-3.93 8.75-8.75-3.92-8.75-8.75-8.75z" /><path d="m22.0004 22.7499c-.19 0-.38-.07-.53-.22l-2-2c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z" /></g></svg>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </p-tabpanel>-->
            </p-tabpanels>
          </p-tabs>
      </div>
    </div>
  </div>
</div>
</div>
<!--<router-outlet></router-outlet>-->
